import { useRef } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { QRCodeSVG } from "qrcode.react";
import { useReactToPrint } from "react-to-print";
import { Printer } from "lucide-react";
import { PN_TYPE_LABELS, type DesignPartNumber } from "@/types/design";

interface Props {
  open: boolean;
  onOpenChange: (o: boolean) => void;
  pn: DesignPartNumber | null;
  customerName?: string;
}

export function PartNumberLabelDialog({ open, onOpenChange, pn, customerName }: Props) {
  const printRef = useRef<HTMLDivElement>(null);
  const handlePrint = useReactToPrint({
    contentRef: printRef,
    documentTitle: `Etiqueta-${pn?.pn_code || "PN"}`,
  });

  if (!pn) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader><DialogTitle>Etiqueta del PN</DialogTitle></DialogHeader>

        {/* Contenido imprimible */}
        <div ref={printRef} className="p-4">
          <div className="border-2 border-black rounded-lg p-4 flex gap-4 items-center" style={{ pageBreakInside: "avoid" }}>
            <QRCodeSVG value={pn.pn_code} size={120} level="H" includeMargin />
            <div className="flex-1 min-w-0">
              <p className="text-[10px] uppercase tracking-wide text-gray-500">{PN_TYPE_LABELS[pn.pn_type]}</p>
              <p className="font-mono font-bold text-sm break-all leading-tight">{pn.pn_code}</p>
              {pn.name && <p className="text-xs mt-1">{pn.name}</p>}
              {customerName && <p className="text-[11px] text-gray-600 mt-1">Cliente: {customerName}</p>}
              {pn.client_part_pn && <p className="text-[11px] text-gray-600">PN cliente: {pn.client_part_pn}</p>}
              <p className="text-[9px] text-gray-400 mt-2">Madelmold MES</p>
            </div>
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cerrar</Button>
          <Button onClick={() => handlePrint()} className="gap-2"><Printer className="w-4 h-4" />Imprimir</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
